export enum SessionStatus {
	ENDUSER = 0,
	ANALYST = 1,
}
